import { render } from "./_retention_table.vue?vue&type=template&id=717b55c0&scoped=true"
import script from "./_retention_table.vue?vue&type=script&lang=js"
export * from "./_retention_table.vue?vue&type=script&lang=js"

import "./_retention_table.vue?vue&type=style&index=0&id=717b55c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717b55c0"]])

export default __exports__